import constants from "./constants";
import createAction from "sagas/createAction";
import { createPromiseAction } from "@adobe/redux-saga-promise";

const actions = {
  getBusinessAccount: createPromiseAction(constants.GET_BUSINESS_ACCOUNT),
};

export default actions;
